import React from 'react'
import {locale} from '../locale/AppLocale';
import {NotificationManager} from '../Helpers/NotificationManager';
import {flattenReduceObject} from '../Helpers/flattenObject'
import isEmpty from 'validator/lib/isEmpty';
import isInt from 'validator/lib/isInt';
import isFloat from 'validator/lib/isFloat';
import trim from 'validator/lib/trim';


export const validateBasics = (values, props = {}) => {

    let errors = {}
    if (!values.title_ar || isEmpty(trim(values.title_ar))) {
        errors.title_ar = locale.get('product_arabic_title_is_required');
    }

    if (!values.description_ar || isEmpty(trim(values.description_ar.replace(/(<([^>]+)>)/ig, "")))) {
        errors.description_ar = locale.get('product_arabic_description_is_required');
    }

    // if(props.initialValues.variantsIndexes.length === 0){
    //     if (!values.images || !Array.isArray(values.images) || values.images.length === 0) {
    //         errors.images = locale.get('product_images_required');
    //     }
    // }

    return errors

};

export const validateAttributesGroup = (values, group) => {
    let errors = {};
    group.properties.forEach((field, index) => {
        if (field.is_required &&
            ((!values[field.name] && parseInt(values[field.name], 10) !== 0) || values[field.name].length === 0)) {
            errors[field.name] = locale.get('required', {field: field.title_ar});
        } else if (field.is_required
            && field.has_other
            && values[field.name] === -1
            && !values[field.name + '_other']) {
            errors[field.name + '_other'] = locale.get('required', {field: field.title_ar});
        }
    });
    return errors;
};

export const validateVariants = (variants) => {
    const errors = {};
    let atLeastOneVariant = true;
    if (variants.length === 0) {
        atLeastOneVariant = false
    }
    variants.forEach((variant, index) => {
        let error = {};
        if (!variant.is_active || variant.is_active !== true) {
            return error;
        } else {
            atLeastOneVariant = false;
        }
        if (!variant.price) {
            error.price = locale.get('required', {
                'field': locale.get('price')
            });
        }

        if (variant.old_price && !isEmpty(trim(variant.old_price))) {
            if (!isFloat(variant.old_price)) {
                error.old_price = locale.get('numeric_only');
            }
        }

        if (!variant.sku) {
            error.sku = locale.get('required', {
                'field': locale.get('sku')
            });
        }
        if (!variant.barcode) {
            error.barcode = locale.get('required', {
                'field': locale.get('barcode')
            });
        }
        if (!variant.quantity) {
            error.quantity = locale.get('required', {
                'field': locale.get('quantity')
            });
        }

        // if (!variant.images || !Array.isArray(variant.images) || variant.images.length === 0) {
        //     error.images = locale.get('product_images_required');
        // }


        if (Object.keys(error).length > 0) {
            errors[index] = error;
        }


    });


    if (atLeastOneVariant) {
        errors.at_least_one_variant = atLeastOneVariant
    }
    return errors
};

export const ValidateProduct = (values, props) => {

    let errors = validateBasics(values, props)

    props.productSpecs.attributes.forEach((group, index) => {
        errors = {...errors, ...validateAttributesGroup(values, group)};
    });

    if (props.withVariants === true && values.variants) {
        errors.variants = validateVariants(values.variants);
        if (errors.variants.at_least_one_variant) {
            errors.at_least_one_variant = locale.get('at_least_one_variant_required')
            delete errors.variants.at_least_one_variant
        }
    }

    return errors;
};


const getNotificationMessage = (errors) => {
    let messages = Object.keys(errors).map((error) => {
        if (typeof errors[error] === 'string') {
            return <div key={error}>{errors[error]}</div>
        }
        return null
    });
    return (<div>{messages}</div>);
}


export const publishErrors = (errors) => {
    errors = flattenReduceObject(errors);
    const totalErrors = Object.keys(errors).length
    if (totalErrors) {
        NotificationManager.error(getNotificationMessage(errors), locale.get('failed_validation_notificant_title')(totalErrors));
    }
};

export const validatePrimarySellingProps = (values, props) => {

    const errors = {}
    let handling_time = values.handling_time;
    if (typeof handling_time === 'object' && typeof handling_time.value !== 'undefined'){
        handling_time = handling_time.value;
    }
    if (!handling_time || !isInt(handling_time.toString())) {
        errors.handling_time = locale.get('required', {
            field: locale.get('handling_time')
        });
    }

    if (!values.pcondition) {
        errors.pcondition = locale.get('required', {
            field: locale.get('pcondition')
        });
    }

    // if (!values.shipping_delivery_option) {
    //     errors.shipping_delivery_option = locale.get('required', {
    //         field: locale.get('shipping_delivery_option')
    //     });
    // }


    if (!values.pickup_from || !isInt(values.pickup_from.toString())) {
        errors.pickup_from = locale.get('required', {
            field: locale.get('pickup_from')
        });
    }

    return errors
}

export const validateSellingProps = (values, props) => {

    let errors = {};

    if (!values.quantity || isEmpty(trim(values.quantity))) {
        errors.quantity = locale.get('required', {
            'field': locale.get('quantity')
        });
    } else if (!isInt(values.quantity)) {
        errors.quantity = locale.get('required', {
            'field': locale.get('numeric_only')
        });
    }

    if (!values.price || isEmpty(trim(values.price))) {
        errors.price = locale.get('required', {
            'field': locale.get('price')
        });
    } else if (!isFloat(values.price)) {
        errors.price = locale.get('numeric_only', {
            'field': locale.get('price')
        });
    }


    if (values.old_price && !isEmpty(trim(values.old_price.toString())) && !isFloat(values.old_price.toString())) {
        errors.old_price = locale.get('numeric_only', {
            'field': locale.get('old_price')
        });
    }

    if (values.notes && !isEmpty(trim(values.notes.toString()))) {
        let _notes = trim(values.notes.toString());
        _notes = _notes.replace(/(<([^>]+)>)/ig, "")
            .replace(/&nbsp;/gi, ' ');
        if (_notes.length > 500) {
            errors.notes = locale.get('string_max_length_exceeded', {size: 500});
        }
    }

    errors = {...errors, ...validatePrimarySellingProps(values, props)}

    return errors;
};

export const validateSeller = (values, props) => {
    let errors = {};
    if (!values.title_ar || isEmpty(trim(values.title_ar))) {
        errors.title_ar = locale.get('required');
    }
    errors = {...errors, ...validateSellingProps(values, props)}
    return errors;
};
